import { gql } from 'graphql-request'

export const GET_LIVE_CHECKIN_LEVELS = gql`
  query GET_LIVE_CHECKIN_LEVELS(
    $take: Int
    $skip: Int
    $active: Boolean
    $deleted: Boolean
  ) {
    getLiveCheckinLevels(
      take: $take
      skip: $skip
      active: $active
      deleted: $deleted
    ) {
      status
      error
      totalPages
      data {
        id
        level
        nameKey
        internalName
        descriptionKey
        internalDescription
        imgLevel
        pointsRequired
        active
      }
    }
  }
`
